import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

// Components
import Header4 from "./components/Header4";
import Footer4 from "./components/Footer4";

// Pages
import Home4 from "./pages/Home4";
import Pricing from "./pages/Pricing";
import Workout from "./pages/Workout";
import Gallery from "./pages/Gallery";
import Trainers from "./pages/Trainers";
import Contact from "./pages/Contact";
import Faqs from "./pages/Faqs";
import About from "./pages/About";
import Services from "./pages/Services";

function App() {
  return (
    <div className="App">

      <Header4 />

      <main>
        <Routes>
          <Route path="/" element={<Home4 />} />
          <Route path="/plans" element={<Pricing />} />
          <Route path="/workouts" element={<Workout />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/trainers" element={<Trainers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
        </Routes>
      </main>

      <Footer4 />

    </div>
  );
}

export default App;
